export enum TAG_TYPES {
  TOPIC = 'topic',
  SPEAKER = 'speaker',
  SCRIPTURE = 'scripture',
}
